<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  width: 100%;
  height: 22vh;
  margin: 0 auto;
  color: #fff;
  text-align: center;
  // overflow: hidden;


  .area {
    width: 100%;
    height: 120%;
    margin-top:-1vh;

    .main {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="table">
      <div class="area">
        <div class="main"></div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from "../common/boxWrap";
import echarts from "echarts";
export default {
  data() {
    return {
      name: "公众号新增人数",
      dataY: [],
      dataX: [],
      tableData: []
    };
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener(
        "resize",
        function() {
          this.myChart.resize();
        }.bind(this)
      );
    },
    getData() {
      this.myChart = echarts.init(document.querySelector(".area .main"));
      this.myChart.clear();
      this.chart();
    },
    chart() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.querySelector(".area .main"));
      this.myChart.setOption({
        grid: {
          top: "15%",
          left: "5%",
          right: "5%",
          bottom: "3.6%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              lineStyle: {
                color: "#0177d4"
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              interval: 0,
              color: "#fff",
              fontSize: 16
            },
            data: ["领抵扣券", "大转盘", "翻牌活动", "微信红包", "刮刮乐"]
          }
        ],
        yAxis: [
          {
            type: "value",
            // splitLine: {
            //   show: false
            // },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#144088"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#144088"
              }
            },
            axisLabel: {
              interval: 0,
              color: "#30ABE7",
              fontSize: 14
            }
          },
          {
            name: "数量：个",
            nameTextStyle: {
              color: "#fff",
              fontSize: 14,
              position: "right",
              padding: [10, 4, 0, -30]
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "注册总量",
            type: "line",
            smooth: false, // 是否平滑曲线显示
            showAllSymbol: true,
            symbol: "emptyCircle",
            symbolSize: 10,
            lineStyle: {
              normal: {
                color: "#3EF7AE" // 线条颜色
              }
            },
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#fff"
              }
            },
            itemStyle: {
              color: "#3EF7AE",
              borderColor: "#3EF7AE",
              borderWidth: 3
            },
            tooltip: {
              show: false
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(0,246,110,0.5)"
                    },
                    {
                      offset: 0.8,
                      color: "rgba(26,247,255,0.5)"
                    }
                  ],
                  false
                )
              }
            },
            data: [18124, 34142, 6355, 25102, 43234]
          }
        ]
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    var self = this;
    self.chart();
    self.init();
    this.timer = setInterval(() => {
      self.getData();
    }, 5000);
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?5b92be80